module.exports = __webpack_public_path__ + "d03049d24d26c213af9afbe6c84c3226.png";